import axios from 'axios';
export const downloadFile = (dataBlob: Blob, fileName: string) => {
    let a = document.createElement('a');
    a.href = URL.createObjectURL(dataBlob);
    a.target = '_blank';
    a.download = fileName || 'fileName';
    a.style.display = 'none';
    document.body.append(a);
    a.click();
    document.body.removeChild(a);
};

export const downloadByUrl = async (url: string, fileName: string) => {
    const response = await axios({
        method: 'get',
        url,
        responseType: 'blob'
    });
    downloadFile(new Blob([response.data]), fileName);
};
